// Function to calculate the average of an array of numbers
export const average = (array: number[]) => {
  if (array.length === 0) return 0;
  return array.reduce((a, b) => a + b, 0) / array.length;
};

export function percentChange(previous: number, current: number) {
  if (previous === 0 && current > 0) return 100;
  if (previous === 0 && current === 0) return 0;
  if (previous === 0 && current < 0) return -100;

  const result = Math.abs((current - previous) / previous) * 100;
  return current > previous ? result : -result;
}

export const clamp = (value: number, min?: number, max?: number) => {
  let result = value;
  if (typeof min === "number") {
    result = Math.max(min, result);
  }
  if (typeof max === "number") {
    result = Math.min(max, result);
  }
  return result;
};
